import { render, staticRenderFns } from "./TenancyDepositReleaseInstabank.vue?vue&type=template&id=68b655db&scoped=true&"
import script from "./TenancyDepositReleaseInstabank.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositReleaseInstabank.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDepositReleaseInstabank.vue?vue&type=style&index=0&id=68b655db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b655db",
  null
  
)

export default component.exports